module.exports = __webpack_public_path__ + "img/huis.09d6d6f2.jpg";